import { render, staticRenderFns } from "./SantamClaimsLadumaAwardEndorse.vue?vue&type=template&id=7fad2e92&v-if=isLoggedIn&"
import script from "./SantamClaimsLadumaAwardEndorse.vue?vue&type=script&lang=js&"
export * from "./SantamClaimsLadumaAwardEndorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports